import {Model} from 'backbone';
import {clone, map, propEq} from 'ramda';
import {set} from '@sinclair-digital/sbg-util/dist/es/object';
import {
    defaultOptions,
    setBroadcastChannelList,
    setBroadcastChannel,
    getSelectedBroadcast,
} from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/models/mediaSearchOptions';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';

const myMediaFilterEnabled = () => getFeatureFlag('myMediaFilter');

// enableFilters :: [Filter] -> [Filter]
const enableFilters = map(set('disabled', false));

// disableFilters :: [Filter] -> [Filter]
const disableFilters = map(set('disabled', true));

export default Model.extend({
    initialize({scopeFilters, packageTypeFilters, fieldFilters, fromDate, thruDate, searchText, myMedia} = {}) {
        this.set(clone(defaultOptions));
        const {scope, myMedia: defaultMyMedia, packageType, field, searchText: defaultSearchText} = this.toJSON();

        scope.filters = scopeFilters || scope.filters;
        scope.filters.some(opt => {
            if (opt.name === 'my') {
                if (!opt.value.length) {
                    opt.value = this.userModel.getAvailableTargetsJSON().map(t => t.site.name);
                }
                return true;
            }
            return false;
        });
        if (myMediaFilterEnabled()) {
            defaultMyMedia?.filters?.forEach(opt => {
                if (myMedia) {
                    opt.selected = opt.name === myMedia;
                }
                if (opt.name === 'my') {
                    if (!opt.value.length) {
                        const user = this.userModel.get('user').uuid + '';
                        opt.value = [
                            {
                                'indexSearchTerms': {
                                    'tag_dimension_created_by': [user],
                                },
                            },
                        ];
                    }
                }
            });

            this.set('myMedia', defaultMyMedia);
        }

        packageType.filters = packageTypeFilters || packageType.filters;
        field.filters = fieldFilters || field.filters;

        this.set('scope', scope);
        this.set('packageType', packageType);
        this.set('field', field);
        this.set('fromDate', fromDate);
        this.set('thruDate', thruDate);
        this.set('searchText', searchText || defaultSearchText);
        this.on('change', this.prepareAllowedFilters);
        this.prepareAllowedFilters();
    },
    prepareAllowedFilters() {
        const scopeFilters = this.get('scope').filters;
        const packageFilters = this.get('packageType').filters;
        const fieldFilters = this.get('field').filters;
        const matchName = propEq('name');
        const allFilter = packageFilters.find(matchName('all'));
        const broadcastFilter = packageFilters.find(matchName('broadcast'));

        let newScopeFilters = enableFilters(scopeFilters);
        let newFieldFilters = enableFilters(fieldFilters);

        if (broadcastFilter.selected) {
            newScopeFilters = disableFilters(scopeFilters);
            newFieldFilters = disableFilters(fieldFilters);
        } else {
            const tagFilter = newFieldFilters.find(matchName('tags'));
            tagFilter.disabled = allFilter && !allFilter.selected;
        }

        this.setFilters('scope', newScopeFilters);
        this.setFilters('field', newFieldFilters);
    },
    setFilters(groupName, filters) {
        const oldFilterGroup = this.get(groupName);
        Model.prototype.set.call(this, {[groupName]: {...oldFilterGroup, filters}}, {silent: true});
    },
    setBroadcastChannelList(channels) {
        setBroadcastChannelList(channels, this.attributes).map(attrs => this.set(attrs));
    },
    setBroadcastChannel(callLetters) {
        setBroadcastChannel(callLetters, this.attributes).map(attrs => this.set(attrs));
    },
    getSelectedBroadcast() {
        return getSelectedBroadcast(this.attributes).getOrElse(null);
    },
});
